<form (submit)="submit()" [formGroup]="fatherForm">

    <div class="form-group row">
        <!-- Inicio ingresar texto -->
        <div class="textOnInput col-12">
            <label class="form-label">Ingrese contenido</label>
            <textarea class="form-control" rows="10" formControlName="textbox"
                (ngModelChange)="modelChangefn($event)"></textarea>
            <div *ngIf="textbox.invalid && (textbox.dirty|| textbox.touched)" class="alert alert-danger">
                <div *ngIf="textbox.errors.required">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Ingrese el texto para crear las
                    subsecciones!
                </div>
            </div>
        </div>
        <!-- Fin  ingresar texto -->
    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <ng-container *ngIf="!isSectionBlocked">
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </ng-container>
            </div>
        </div>
    </div>

</form>